import { Box, Typography } from "@mui/material";
import React from "react";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { TooltipRenderProps } from "react-joyride";

interface TourGuideProps {
  steps: Step[];
  setCurrentStep: (step: number) => void;
  handleClose: () => void;
}

const TourGuide = ({ steps, setCurrentStep, handleClose }: TourGuideProps) => {
  const CustomTooltip = ({
    continuous,
    index,
    step,
    backProps,
    skipProps,
    primaryProps,
    tooltipProps,
  }: TooltipRenderProps) => {
    return (
      <div {...tooltipProps} className="joyride-custom-tooltip">
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontWeight: "700",
            fontSize: " 14px",
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >
          {step.title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >
          {step.content}
        </Typography>
        <div className="tooltip-footer">
          <Typography
            sx={{
              opacity: "0.5",
              fontFamily: "Roboto",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "24px",
              letterSpacing: "0.15px",
            }}
          >
            {index + 1 + "/" + steps?.length}
          </Typography>
          {continuous && (
            <button className="apply-btn not-disable" {...primaryProps}>
              {index === steps?.length - 1 ? "End tour" : "Next"}
            </button>
          )}
        </div>
      </div>
    );
  };
  return (
    <Joyride
      steps={steps}
      run={true}
      disableOverlay={true}
      disableScrolling={true}
      tooltipComponent={CustomTooltip}
      continuous
      scrollToFirstStep={false}
      showProgress
      hideBackButton
      styles={{
        options: {
          zIndex: 10000,
          arrowColor: "var(--M-background120)",
        },
        overlay: {
          backgroundColor: "transparent",
        },
      }}
      callback={(data: CallBackProps) => {
        const { action, index, status, type } = data;
        if (type === "step:after" || type === "step:before") {
          setCurrentStep(index);
        }
        if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
          handleClose();
          setCurrentStep(0);
        }
      }}
    />
  );
};

export default TourGuide;
